import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/landlord/roles";
export default {
  getChannelPartnerList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, tenant_id) {
    if(tenant_id) return Repository.get(`/landlord/tenant/${tenant_id}/channel-partners?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`) 
    return Repository.get(`/landlord/marketing/channel-partners?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getListNoPagination() {
    return Repository.get(`${resource}?is_paginate=0`)
  },
  getChannelPartnerCustomers(pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/customers?paginate=${pagination}&page=${pageNumber}`)
  },
  getChannelPartner(resource_id) {
    return Repository.get(`/landlord/marketing/channel-partners/${resource_id}`)
  },
  // updateChannelPartner(tenant_id, resource_id, payload) {
  //   return Repository.put(`/landlord/tenant/${tenant_id}/channel-partners/${resource_id}`, payload)
  // },
  updateChannelPartner(resource_id, payload) {
    return Repository.put(`/landlord/marketing/channel-partners/${resource_id}`, payload)
  },
  createChannelPartner(payload, tenant_id) {
    if(tenant_id) return Repository.post(`/landlord/tenant/${tenant_id}/channel-partners`, [ payload ])
    return Repository.post(`/landlord/marketing/channel-partners`, payload)
  },
  createChannelPartnerAgreement(resource_id, payload) {
    return Repository.post(`/landlord/marketing/channel-partners/${resource_id}/partner-customers`, payload)
  },
  getCustomerAgreements(customer_id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/customers/${customer_id}/agreements?paginate=${pagination}&page=${pageNumber}`)
  },
  createChannelPartnerCustomerAndAgreement(partner_id, payload) {
    return Repository.post(`/landlord/marketing/channel-partners/${partner_id}/partner-customers`, payload)
  },
  cretaeChannelPartnerAgreemen(customer_id, payload) {
    return Repository.post(`/landlord/marketing/partner-customers/${customer_id}/agreements`, payload)
  },

  getChannelPartnerUsers(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/users?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  }
};
